
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campus2022",
      function () {
        return require("private-next-pages/campus2022/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campus2022"])
      });
    }
  